var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99603 17.2403C12.3498 16.859 15.0376 14.1378 15.4201 10.7337C15.9221 6.28267 12.5137 2.49378 8.24126 2.44525V0.448535C8.24126 0.337607 8.10465 0.278676 8.01244 0.348006L3.96196 3.36734C3.89365 3.41933 3.89365 3.51986 3.96196 3.57186L8.01244 6.59119C8.10465 6.66052 8.24126 6.59812 8.24126 6.49066V4.49742C11.2433 4.54595 13.6476 7.1389 13.4427 10.238C13.2685 12.9037 11.1271 15.0668 8.50082 15.2367C5.71739 15.4169 3.35063 13.3994 2.92714 10.7302C2.84859 10.2345 2.42168 9.87398 1.92989 9.87398C1.31856 9.87398 0.840423 10.4252 0.93605 11.0387C1.5303 14.8415 4.98995 17.6944 8.99603 17.2403Z",
    fill: "#E87722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a058ec10ffd9f9ef3c5ecc3dffbdeeaf.svg";
export { ForwardRef as ReactComponent };